// Thin wrappers around fetch/PostgREST responses.
import { supabase } from "../supabase-client.js";

export async function readApiResponse(response, fallbackMessage) {
  const rawBody = await response.text();
  let payload = {};

  if (rawBody) {
    try {
      payload = JSON.parse(rawBody);
    } catch {
      payload = { message: rawBody };
    }
  }

  if (!response.ok) {
    const candidateMessage = payload?.message
      || payload?.error_description
      || (typeof payload?.error === "string" ? payload.error : null)
      || (rawBody && rawBody !== "{}" ? rawBody : null)
      || fallbackMessage;
    const message = !candidateMessage
      || candidateMessage === "{}"
      || candidateMessage === "[object Object]"
      ? fallbackMessage
      : candidateMessage;
    throw new Error(message);
  }

  return payload;
}

export async function fetchAllRPC(functionName, parameters = {}, pageSize = 1000) {
  const rows = [];
  let from = 0;

  while (true) {
    const { data, error } = await supabase
      .rpc(functionName, parameters)
      .range(from, from + pageSize - 1);
    if (error) return { data: null, error };
    const page = data || [];
    rows.push(...page);
    if (page.length < pageSize) return { data: rows, error: null };
    from += pageSize;
  }
}

export function readableError(error, fallbackMessage) {
  if (error instanceof Error && error.message && error.message !== "{}") return error.message;
  if (typeof error === "string" && error.trim()) return error;
  if (error && typeof error.message === "string" && error.message.trim() && error.message !== "{}") return error.message;
  return fallbackMessage;
}
